import { connect } from 'react-redux';

const mapStateToProps = state => ({
  urls: state.mainreducer.urls,
  formAuthToken: state.mainreducer.formAuthToken,
  formPostUrl: state.mainreducer.signupFormUrl
});

export default ProviderPageLeftPart => connect(mapStateToProps, null)(ProviderPageLeftPart);
